import { Button, Text, VSpacer } from '@/components/DesignSystem';
import { useAuthentication } from '@/contexts/dataSync/AuthenticationContext';
import { Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Shown to someone signed in to the shared login whose login no longer lists LP. AIM and AIR show
 * the same page in their own colours.
 */
export const NoLpAccessPage = () => {
  const { t } = useTranslation();
  const { logout, platformLinks } = useAuthentication();

  return (
    <Stack alignItems="center" justifyContent="center" minHeight="100vh" paddingX="16px">
      <Stack alignItems="center" maxWidth="480px" textAlign="center">
        <Text category="title-medium" testID="no-lp-access-title">
          {t($ => $.auth.noLpAccess.notAuthorized)}
        </Text>
        <VSpacer size="6" />
        {platformLinks.length > 0 && (
          <>
            <Text category="body-large" testID="no-lp-access-available-products">
              {t($ => $.auth.noLpAccess.availableProducts)}
            </Text>
            <VSpacer size="3" />
            <Stack direction="row" flexWrap="wrap" gap={1} justifyContent="center">
              {platformLinks.map(({ code, url }) => (
                <Button
                  key={code}
                  onClick={() => window.location.assign(url)}
                  testID={`no-lp-access-open-${code}`}
                  variant="contained"
                >
                  {t($ => $.auth.noLpAccess.openProduct, { product: code })}
                </Button>
              ))}
            </Stack>
            <VSpacer size="5" />
          </>
        )}
        <Button
          onClick={() => void logout()}
          testID="no-lp-access-sign-out"
          variant="outlined"
        >
          {t($ => $.auth.noLpAccess.signOut)}
        </Button>
      </Stack>
    </Stack>
  );
};
